import * as api from "./api";

let TURNIceSevers = null;

export const fetchTurnCredentials = async () => {
    const responseData = await api.getTurnCredentials();

    if (responseData.token?.iceServers) {
        TURNIceSevers = responseData.token.iceServers;
    }

    return TURNIceSevers;
};

export const getTurnCredentials = () => {
    return TURNIceSevers;
};
